import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static classes = [
        'true',
        'false',
    ]

    connect() {
        this.handle()

        addEventListener('scroll', this.handle.bind(this))
    }

    disconnect() {
        removeEventListener('scroll', this.handle.bind(this))
    }

    get classNames() {
        return [
            ...this.trueClasses.map(className => ({ className, force: true })),
            ...this.falseClasses.map(className => ({ className, force: false })),
        ]
    }

    handle() {
        const isTop = window.pageYOffset === 0;

        this.classNames.forEach(({className, force}) => {
            this.element.classList.toggle(className, isTop === force)
        });
    }
}
